export default [
  { to: 'lakemedel', title: 'Läkemedel' },
  { to: 'showroom', title: 'Showroom' },
  { to: 'ambulans', title: 'Ambulans' },
  { to: 'strama', title: 'Strama' },
];
